exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container___container___1Sjxu {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: flex;\n    color: #fff;\n    font-family: \"DAZNOscine\", \"Oscine\", \"DAZNRgNow\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n}\n\n.container___close___19LNn {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 12px 16px;\n}\n\n.container___close___19LNn svg {\n    width: 1.2rem;\n    fill: currentColor;\n}\n\n.container___close___19LNn:hover {\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"container": "container___container___1Sjxu",
	"close": "container___close___19LNn"
};